// The routes this module owns, as the app mounts them. `route.ts` takes its mount from here and
// `src/app/paths.ts` merges this into the one `paths` object, so a link and a route cannot drift.

/** Base path of the Organizations console. Inside the module this is imported by name; the rest of the
 *  app reaches it as `paths.organizations.base` (`@/lib/paths`). */
export const ORG_BASE = '/services/organizations';

export const organizationsPaths = {
  base: ORG_BASE,
} as const;
